import { z } from 'zod';
// =====================================================
// MESSAGE TYPES
// =====================================================
export var MessageChannel;
(function (MessageChannel) {
    MessageChannel["SMS"] = "sms";
    MessageChannel["EMAIL"] = "email";
})(MessageChannel || (MessageChannel = {}));
export var MessageDirection;
(function (MessageDirection) {
    MessageDirection["INBOUND"] = "inbound";
    MessageDirection["OUTBOUND"] = "outbound";
})(MessageDirection || (MessageDirection = {}));
export var MessageStatus;
(function (MessageStatus) {
    MessageStatus["PENDING"] = "pending";
    MessageStatus["SENT"] = "sent";
    MessageStatus["DELIVERED"] = "delivered";
    MessageStatus["FAILED"] = "failed";
    MessageStatus["READ"] = "read";
})(MessageStatus || (MessageStatus = {}));
// =====================================================
// CONVERSATION TYPES
// =====================================================
export var ConversationStatus;
(function (ConversationStatus) {
    ConversationStatus["OPEN"] = "open";
    ConversationStatus["PENDING"] = "pending";
    ConversationStatus["RESOLVED"] = "resolved";
    ConversationStatus["CLOSED"] = "closed";
})(ConversationStatus || (ConversationStatus = {}));
// =====================================================
// USER TYPES
// =====================================================
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "admin";
    UserRole["MANAGER"] = "manager";
    UserRole["AGENT"] = "agent";
    UserRole["VIEWER"] = "viewer";
})(UserRole || (UserRole = {}));
// =====================================================
// ZOD SCHEMAS FOR VALIDATION
// =====================================================
export const MessageChannelSchema = z.enum(['sms', 'email']);
export const MessageDirectionSchema = z.enum(['inbound', 'outbound']);
export const MessageStatusSchema = z.enum(['pending', 'sent', 'delivered', 'failed', 'read']);
export const ConversationStatusSchema = z.enum(['open', 'pending', 'resolved', 'closed']);
export const UserRoleSchema = z.enum(['admin', 'manager', 'agent', 'viewer']);
export const CreateMessageSchema = z.object({
    conversationId: z.uuid(),
    channel: MessageChannelSchema,
    direction: MessageDirectionSchema,
    from: z.string(),
    to: z.string(),
    subject: z.string().optional(),
    body: z.string().min(1),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
export const CreateConversationSchema = z.object({
    subject: z.string().optional(),
    channel: MessageChannelSchema,
    participantEmail: z.email().optional(),
    participantPhone: z.string().optional(),
});
export const UpdateConversationSchema = z.object({
    subject: z.string().optional(),
    status: ConversationStatusSchema.optional(),
});
//# sourceMappingURL=types.js.map